module.exports = __webpack_public_path__ + "static/media/sports_18.c6174365.jpg";